export default __webpack_public_path__ + "60b1b9ecf178e07bf5ca29875e0e0e34.png";